/**
Material design: [Radio button](https://www.google.com/design/spec/components/selection-controls.html#selection-controls-radio)

`com-radio` is a button that can be either checked or unchecked.
User can tap the radio button to check or uncheck it.

Use a `<com-radio-group>` to group a set of radio buttons.  When radio buttons
are inside a radio group, exactly one radio button in the group can be checked
at any time.

Example:

    <com-radio></com-radio>
    <com-radio>Item label</com-radio>

### Styling

The following custom properties and mixins are available for styling:

Custom property | Description | Default
----------------|-------------|----------
`--com-radio-size` | Size of the radio button | `16px`
`--com-radio-label` | A mixin applied to the internal label | `{}`
`--com-radio-button-padding` | Radio button padding on the right. Used to extend tappable area | `10px`
`--com-radio-hover-color` | Radio button color when the input is hovered | `var(--primary-hover)`

This element applies the mixin `--com-font-common-base` but does not import `com-styles/typography.html`.
In order to apply the `Roboto` font to this element, make sure you've imported `com-styles/typography.html`.



@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-radio-style.js';

import { COMToggledElementBehavior } from '@com/checked-element-behavior';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import './com-radio-button.js';

class COMRadio extends COMToggledElementBehavior(GestureEventListeners(PolymerElement)) {
  static get template() {
    return html`
    <style include="com-theme"></style>
    <style include="com-radio-style"></style>

    <div id="wrapper">
      <!-- (IE11) this wrapper div is needed to shield #radio from the flex layout -->
      <com-radio-button id="radio" checked="{{checked}}" disabled="[[disabled]]" error="[[error]]" hover="[[hover]]" keyboard-navigation="{{keyboardNavigation}}" aria-labelledby\$="[[ariaId]]"></com-radio-button>
      <div id\$="[[ariaId]]" class="radio-label" on-tap="checkToggleButton" on-mouseenter="checkAddHoverOnLabel" on-mouseleave="removeHover" toggle-button\$="[[!hasToggles]]"><slot id="slot"></slot></div>
    </div>
`;
  }

  static get is() { return 'com-radio'; }
  static get properties() {
    return {
      theme: {
        type: String,
        value: "default",
        reflectToAttribute: true
      },
      checked: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      error: {
        type: Boolean,
        value: false
      },
      disabled: {
        type: Boolean,
        value: false
      },
      hover: {
        type: Boolean,
        value: false
      },
      hasToggles: {
        type: Boolean,
        value: false
      },
      ariaId: {
        type: String,
        computed: '_generateRandId()'
      },
      keyboardNavigation: {
        type: Boolean,
        reflectToAttribute: true
      }
    };
  }

  /**
   * @desc Generate a random ID for a11y. Added this method to fix linting errors
   * @return randomString
   */
  _generateRandId() {
    return super.generateRandId();
  }
}

window.customElements.define(COMRadio.is, COMRadio);
